import { createHistory } from "@reach/router";

let history = createHistory(window);

history.back = () => {
  window.history.back();
};

export default history;
